import { render, staticRenderFns } from "./evaluationModule.vue?vue&type=template&id=0a6ee742&scoped=true&"
import script from "./evaluationModule.vue?vue&type=script&lang=js&"
export * from "./evaluationModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ee742",
  null
  
)

export default component.exports